import { styled } from 'styled-components'

export const BreakdownList = styled.div`
  padding-top: 11.5px;
`

export const BreakdownListInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-left: 12px;
  border-left: 1px solid ${({ theme }) => theme.colors.grayMedium};
`

export const BreakdownRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.black};
`

export const Label = styled.span``

export const LabelCount = styled.span`
  font-weight: 500;
`

export const LabelSize = styled.span`
  font-weight: 400;
`

export const PriceGroup = styled.span`
  display: flex;
  gap: 4px;
  align-items: center;
`

export const OriginalPrice = styled.span`
  text-decoration: line-through;
  color: ${({ theme }) => theme.colors.grayDark};
  font-size: 13px;
`

export const DiscountedPrice = styled.span`
  font-weight: 500;
`
